globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.History = appCustomerSpace.Modals.History || {};

appCustomerSpace.Modals.History.CoachingRegister = (function(superClass) {

  utils.extend(CoachingRegister, superClass);

  function CoachingRegister() {
    return CoachingRegister.__super__.constructor.apply(this, arguments);
  }

  $.extend(CoachingRegister.prototype, {});

  return CoachingRegister;

})(appCustomerSpace.Modal);
